"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as a } from "react/jsx-runtime";
import { useTheme as i } from "../../hooks.js";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const h = (_param)=>{
    var { color: r, size: l = 24 } = _param, c = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const n = s(), e = r !== null && r !== void 0 ? r : n ? o.colors.inverse : o.colors.neutralHigh, { skinName: t } = i();
    return t.match(/^o2-new/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, c), {
        children: /* @__PURE__ */ a("path", {
            fill: e,
            d: "m18.688 16.4 1.81 1.973a.74.74 0 0 1-.022 1.02.68.68 0 0 1-.985-.027l-1.797-1.958a1.71 1.71 0 0 0-2.448.013l-3.472 3.632c-.611.63-1.418.947-2.22.947a3.08 3.08 0 0 1-2.217-.947 3.26 3.26 0 0 1-.918-2.285c0-.487.107-.956.303-1.383a3.6 3.6 0 0 1-1.841-1.003l-1.012-1.034c-.339-.35-.54-.8-.566-1.278a1.75 1.75 0 0 1 .477-1.324l1.516-1.581c.668-.699 1.8-.667 2.523.069l1.061 1.085c.468.482 1.739.193 3.161-1.288 1.413-1.475 1.676-2.78 1.204-3.263l-1.061-1.08c-.723-.736-.763-1.904-.094-2.603l1.516-1.581c.668-.699 1.8-.667 2.523.069l1.012 1.034c1.066 1.085 1.369 2.717.852 4.593-.486 1.77-1.654 3.654-3.38 5.452-1.73 1.802-3.553 3.034-5.27 3.558a7 7 0 0 1-.949.211l-.085.088c-.316.33-.499.781-.499 1.26 0 .477.178.928.508 1.268a1.707 1.707 0 0 0 2.461 0l3.473-3.632a3.066 3.066 0 0 1 4.436-.004M4.69 13.984a.52.52 0 0 0 .156.34l1.008 1.034c.584.598 1.346.736 2.064.676a.6.6 0 0 1 .2-.023c.29-.037.571-.101.825-.18 1.472-.445 3.13-1.58 4.677-3.19 1.534-1.6 2.613-3.314 3.027-4.831.263-.956.393-2.28-.49-3.181l-1.012-1.034c-.174-.175-.424-.212-.553-.079l-1.516 1.582c-.125.133-.089.395.085.57l1.061 1.08c1.177 1.2.695 3.328-1.195 5.296-1.894 1.972-3.959 2.496-5.131 1.296l-1.061-1.085a.5.5 0 0 0-.348-.16.27.27 0 0 0-.205.078l-1.516 1.58a.29.29 0 0 0-.076.23"
        })
    })) : /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, c), {
        children: /* @__PURE__ */ a("path", {
            fill: e,
            d: "m18.688 16.4 1.81 1.973a.74.74 0 0 1-.022 1.02.68.68 0 0 1-.985-.027l-1.797-1.958a1.71 1.71 0 0 0-2.448.013l-3.473 3.632c-.61.63-1.417.947-2.22.947a3.08 3.08 0 0 1-2.216-.947 3.26 3.26 0 0 1-.918-2.285c0-.487.107-.956.303-1.383a3.6 3.6 0 0 1-1.841-1.003l-1.012-1.034c-.339-.35-.54-.8-.566-1.278a1.75 1.75 0 0 1 .477-1.324l1.516-1.581c.668-.699 1.8-.667 2.523.069l1.061 1.085c.468.482 1.739.193 3.16-1.288 1.414-1.475 1.677-2.78 1.205-3.263l-1.061-1.08c-.723-.736-.763-1.904-.094-2.603l1.516-1.581c.668-.699 1.8-.667 2.523.069l1.012 1.034c1.066 1.085 1.369 2.717.852 4.593-.486 1.77-1.654 3.654-3.38 5.452-1.73 1.802-3.553 3.034-5.27 3.558a7 7 0 0 1-.949.211l-.085.088c-.316.33-.499.781-.499 1.26 0 .477.178.928.508 1.268a1.707 1.707 0 0 0 2.461 0l3.473-3.632a3.066 3.066 0 0 1 4.436-.004M4.69 13.984a.52.52 0 0 0 .156.34l1.008 1.034c.584.598 1.346.736 2.064.676a.6.6 0 0 1 .2-.023c.29-.037.571-.101.825-.18 1.472-.445 3.13-1.58 4.677-3.19 1.534-1.6 2.613-3.314 3.027-4.831.263-.956.393-2.28-.49-3.181l-1.012-1.034c-.174-.175-.424-.212-.553-.079l-1.516 1.582c-.125.133-.089.395.085.57l1.061 1.08c1.177 1.2.695 3.328-1.195 5.296-1.894 1.972-3.959 2.496-5.131 1.296l-1.061-1.085a.5.5 0 0 0-.348-.16.27.27 0 0 0-.205.078l-1.516 1.58a.29.29 0 0 0-.076.23"
        })
    }));
}, u = h;
export { u as default };
